<template>
  <div>
    <Header />

    <div class="section section-about section-pad bg-light">
      <div class="container">
        <div class="content row">
          <div class="wide center">
            <h1 class="heading-section">CONTACT US</h1>

          </div>
        </div>
      </div>
    </div>

    <div class="section section-content section-pad">
      <div class="container">

        <div>

          <form
            id="contact-form"
            role="form"
          >

            <div class="controls">

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="form_name">Firstname *</label>
                    <input
                      id="form_name"
                      type="text"
                      name="name"
                      class="form-control"
                      placeholder="Please enter your firstname "
                      required="required"
                      data-error="Firstname is required."
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="form_lastname">Lastname *</label>
                    <input
                      id="form_lastname"
                      type="text"
                      name="surname"
                      class="form-control"
                      placeholder="Please enter your lastname "
                      required="required"
                      data-error="Lastname is required."
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="form_email">Email *</label>
                    <input
                      id="form_email"
                      type="email"
                      name="email"
                      class="form-control"
                      placeholder="Please enter your email "
                      required="required"
                      data-error="Valid email is required."
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="form_phone">Phone</label>
                    <input
                      id="form_phone"
                      type="tel"
                      name="phone"
                      class="form-control"
                      placeholder="Please enter your phone"
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="form_message">Message *</label>
                    <textarea
                      id="form_message"
                      name="message"
                      class="form-control"
                      placeholder="Enter your message"
                      rows="4"
                      required
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <input
                    type="submit"
                    class="btn btn-warning btn-send"
                    value="Send message"
                  >
                </div>
              </div>

            </div>

          </form>

        </div>

      </div>
    </div>

    <Footer />
  </div>
</template>

<style>
.heading-section {
  padding-bottom: 20px;
}
.controls {
  width: 80%;
  margin: 30px auto;
}
input.form-control {
  height: 50px;
}
</style>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'

export default {
  name: 'Home',
  data () {
    return {
      openings: [],
      companies: [
        {
          id: '1',
          company_name: 'Sundry Markets'
        }
      ],
      search: {
        selected_company: '0',
        selected_company_error: false,
        query: ''
      }
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    getAllOpenings () {

      var get_openings_request = {
        what: 'openings'
      }

      this.$socket.makeGetRequest(get_openings_request)
        .then((response) => {
          if (response.type == 'openings') {
            response.data.forEach(i => {
              i.company_name = "Sundry Markets";
            });
            this.openings = response.data
            this.$swal.close()
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },

    filterJobs (e) {
      var input = e.target.value
      this.search.query = input

      if (input.length > 0) {
        if (this.search.selected_company == '' || this.search.selected_company == '0') {
          this.search.selected_company_error = true
        } else {
          this.search.selected_company_error = false

          this.getJobsByParams(this.search.selected_company, this.search.query)
        }
      } else {
        this.getAllOpenings()
      }
    },

    getJobsByParams (company_id, query) {
      var search_jobs = {
        what: 'SearchJobs',
        params: {
          company_id: company_id,
          q: query
        },
        showLoader: false
      }

      this.$socket.makeGetRequest(search_jobs)
        .then((response) => {
          //console.log(response)
          if (response.type == 'SearchJobs') {
            this.openings = response.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    getCompanies () {
      var companies = {
        what: 'Companies'
      }

      this.$socket.makeGetRequest(companies)
        .then((response) => {
          if (response.type == "Companies") {
            // console.log(response.data)
            for (var i = 0; i < response.data.length; i++) {
              this.companies.push(response.data[i])
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    filterCompany (e) {
      //console.log(e)
      var company_id = e.target.value
      if (company_id !== "0") {
        this.getJobsByParams(company_id, '')
      } else {
        this.getAllOpenings()
      }
    },

    jobdescription: function (jd) {
      return (jd.length > 250) ? jd.substring(0, 250) + "..." : jd
    }
  },
  mounted () {

    var loading_html = '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>'

    this.$swal.fire({
      title: "<h5></h5>",
      html: loading_html,
      showConfirmButton: false,
      showCancelButton: false,
      allowOutsideClick: false
    })

    this.getAllOpenings()
    this.getCompanies()
  }
}
</script>